import { Theme } from "@emotion/react";
import { SxProps, TableCell, TableRow } from "@mui/material";
import React from "react";

type StyledRowProps = {
  children: JSX.Element | JSX.Element[] | string,
}

export function StyledRow({ children }: StyledRowProps) {
  return (
    <TableRow
      sx={{
        transition: "background-color 0.2s ease",
        "&:hover": { 
          backgroundColor: "#fafafa" 
        },
        "& td": {
          paddingTop: "4px",
          paddingBottom: "2px",
        },
      }}
    >
      {children}
    </TableRow>
  )
}

type DragAndDropRowProps = {
  children: any,
  dragging: boolean,
  indicator: "none" | "top" | "middle" | "bottom",
  onDragOver?: React.DragEventHandler<HTMLTableRowElement> | undefined,
  sx?: SxProps<Theme>
}

export default function DragAndDropRow({ children, dragging, indicator, onDragOver, sx }: DragAndDropRowProps) {
  
  return (
    <React.Fragment>
      {indicator === "top" && <LineRow />}
      <TableRow
        onDragOver={onDragOver}
        sx={{
          ...sx,
          transition: "background-color 0.2s ease",
          background: dragging ? "#f4f4f4" : "white",
          "&:hover": { 
            ...sx?.["&:hover"],
            backgroundColor: "#fafafa" 
          },
          "& > td:first-of-type": {
            ...sx?.["& > td:first-of-type"],
            background: indicator === "middle" ? "green" : "unset",
          },
          "& td": {
            ...sx?.["& td"],
            paddingTop: "4px",
            paddingBottom: "2px",
          },
        }}
      >
        {children}
      </TableRow>
      {indicator === "bottom" && <LineRow />}
    </React.Fragment>
  );
}

function LineRow() {
  return (
    <TableRow>
      <TableCell
        colSpan={99}
        sx={{
          height: "3px",
          background: "green"
        }}
      ></TableCell>
    </TableRow>
  )
}
